import { render, staticRenderFns } from "./link_sprite_icon.vue?vue&type=template&id=3e5c5c1c"
import script from "./link_sprite_icon.vue?vue&type=script&lang=js"
export * from "./link_sprite_icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports